module.exports = __webpack_public_path__ + "static/media/Q_2_10.9c9fac21.jpg";